/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  var Sage = {
    // All pages
    common: {
      init: function () {
        //var $popupCloseButton = document.querySelector('.sticky-footer .st-close.toggle');
        //var $stickyFooter = document.querySelector('.sticky-footer');
        //if ($popupCloseButton) {
        //  $popupCloseButton.addEventListener('click', function(e){
        //    $stickyFooter.classList.toggle('dismissed');
        //    sessionStorage.setItem('alert', 'dismissed');
        //  }, false);
        //}
        //if (sessionStorage.getItem('alert')) {
        //  var alertStatus = sessionStorage.getItem('alert');
        //  if (alertStatus != 'dismissed') {
        //    $stickyFooter.classList.toggle('dismissed');
        //  }
        //} else {
        //  $stickyFooter.classList.toggle('dismissed');
        //}
        var ratings = document.querySelector(".ratings-slider");
        if (ratings) {
          var ratings_slider = tns({
            items: 2,
            nav: false,
            mouseDrag: true,
            controls: true,
            controlsText: [
              '<i class="fa fa-chevron-left"></i>',
              '<i class="fa fa-chevron-right"></i>',
            ],
            slideBy: "page",
            loop: false,
            responsive: {
              600: {
                items: 2,
              },
              900: {
                items: 3,
              },
            },
            container: ".ratings .ratings-slider",
            speed: 500,
          });
        }
        var iFrames = document.querySelectorAll("iframe");
        [].forEach.call(iFrames, function (el) {
          el.setAttribute("ratio", el.offsetHeight / el.offsetWidth);
          el.removeAttribute("width");
          el.removeAttribute("height");
          el.setAttribute("width", el.parentElement.offsetWidth);
          el.setAttribute(
            "height",
            el.parentElement.offsetWidth * el.getAttribute("ratio")
          );
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        // Modal
        var modal = document.querySelector(".modal");
        var modalButton = document.querySelector(".modal-button");
        //  var closeButton = document.querySelector(".close-button");
        var closeButton = document.querySelector('[aria-label="close"]');

        function toggleModal() {
          modal.classList.toggle("is-active");
        }

        function windowOnClick(event) {
          if (event.target === modal) {
            toggleModal();
          }
        }
        if (modal) {
          modalButton.addEventListener("click", toggleModal);
          closeButton.addEventListener("click", toggleModal);
          window.addEventListener("click", windowOnClick);
        }
      },
    },
    home: {
      init: function () {
        function titleCase(str) {
          if (str === null || str === "") return false;
          else str = str.toString();
          return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          });
        }
        var $groupExpect = document.querySelector(
          ".what-to-expect .is-variable"
        );
        var $btnSwap = document.querySelectorAll(".what-to-expect a.button");
        [].forEach.call($btnSwap, function (b) {
          b.addEventListener(
            "click",
            function (e) {
              swapGroup(b, e);
            },
            false
          );
        });
        function swapGroup(b, e) {
          if (window.innerWidth > 770) {
            $groupExpect.classList.toggle("swap");
          } else {
            $groupExpect.classList.toggle("swap", false);
          }
          e.preventDefault();
        }
        function getExcerpt(str, limit) {
          var fullText = str;
          var shortText = str;
          shortText =
            shortText.substr(0, shortText.lastIndexOf(" ", limit)) + "...";
          var returnString = {
            fullText: fullText,
            shortText: shortText,
          };
          return returnString;
        }

        function resizeVictoryText() {
          var victoryText = document.querySelector(".victory").innerHTML;
          var victoryExcerpt = getExcerpt(victoryText, 400);
          if (window.innerWidth < 1024) {
            document.querySelector(".victory").innerHTML =
              victoryExcerpt.shortText;
            document.querySelector(".victories .button").innerHTML =
              "Read More";
          } else {
            document.querySelector(".victory").innerHTML =
              victoryExcerpt.fullText;
            document.querySelector(".victories .button").innerHTML =
              "See More DWI Victories";
          }
        }
        resizeVictoryText();
        var $vc = document.querySelector(".victories-filter");
        $vc.addEventListener(
          "click",
          function (e) {
            if (window.innerWidth < 1024) {
              $vc.classList.toggle("is-active");
            } else {
              $vc.classList.toggle("is-active", false);
            }
          },
          false
        );
        var $l = document.querySelectorAll(".victories-filter li a");
        [].forEach.call($l, function (i) {
          i.addEventListener(
            "click",
            function (e) {
              getVictories(i, e);
            },
            false
          );
        });
        function getVictories(a, e) {
          if (!a.parentElement.classList.contains("active")) {
            $.ajax({
              url: notable_victories.ajax_url,
              type: "post",
              data: {
                action: "notable_victory",
                verdict: a.getAttribute("href").replace("/?verdict=", ""),
              },
              success: function (s) {
                resetClass(
                  document.querySelectorAll(".victories-filter li"),
                  "active"
                );
                document.querySelector(".victory").innerHTML = s;
                a.parentElement.classList.add("active");
                resizeVictoryText();
              },
            });
          }
          e.preventDefault();
        }
        function resetClass(t, c) {
          [].forEach.call(t, function (o) {
            o.classList.remove(c);
          });
        }

        var testimonials_slider = tns({
          items: 1,
          nav: true,
          mouseDrag: true,
          controls: true,
          controlsText: [
            '<i class="fa fa-chevron-left"></i>',
            '<i class="fa fa-chevron-right"></i>',
          ],
          slideBy: "page",
          loop: false,
          container: ".testimonials .testimonials-slider",
          speed: 500,
        });

        var victory_slider = tns({
          items: 1,
          nav: false,
          mouseDrag: true,
          controls: true,
          controlsText: [
            '<i class="fa fa-chevron-left"></i>',
            '<i class="fa fa-chevron-right"></i>',
          ],
          slideBy: "page",
          loop: false,
          container: ".victory .victory-slider",
          speed: 500,
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
    // Notable victories page.
    not_guilty_success_cases: {
      init: function () {
        function getExcerpt(str, limit) {
          var fullText = str;
          var shortText = str;
          shortText =
            shortText.substr(0, shortText.lastIndexOf(" ", limit)) + "...";
          var returnString = {
            fullText: fullText,
            shortText: shortText,
          };
          return returnString;
        }
        function resizeVictoryText() {
          var victoryText = document.querySelectorAll(".victory");

          [].forEach.call(victoryText, function (i) {
            var victoryExcerpt = getExcerpt(i.innerHTML, 400);
            i.innerHTML = victoryExcerpt.shortText;
          });
          // if (window.innerWidth < 1024) {
          //             document.querySelector('.victory').innerHTML = victoryExcerpt.shortText;
          //             document.querySelector('.victories .button').innerHTML = "Read More";
          //           } else {
          //             document.querySelector('.victory').innerHTML = victoryExcerpt.fullText;
          //             document.querySelector('.victories .button').innerHTML = "View More";
          //           }
        }
        resizeVictoryText();
      },
    },
    //tlf-tv page.
    tlf_tv: {
      init: function () {
        var videoSliders = document.querySelectorAll(".videos-slider");
        videoSliders.forEach(function (sliderContainer) {
          var slider = tns({
            container: sliderContainer,
            items: 1,
            slideBy: "page",
            autoplay: false,
            gutter: 30,
            nav: false,
            mouseDrag: true,
            controlsText: [
              '<i class="fa fa-chevron-left"></i>',
              '<i class="fa fa-chevron-right"></i>',
            ],
            responsive: {
              480: {
                items: 2,
              },
              1000: {
                items: 3,
              },
            },
          });
        });

        $("#btn_hero_video_player").click(function () {
          console.log("click video");
          var $iframe = $(this).data("iframe");
          $("#video_modal .modal-content").empty();
          $("#video_modal .modal-content").append($iframe);
          $("#video_modal").addClass("is-active");
        });

        $(".video-thumbnail .btn-play").click(function () {
          var $iframe = $(this).data("iframe");
          $("#video_modal .modal-content").empty();
          $("#video_modal .modal-content").append($iframe);
          $("#video_modal").addClass("is-active");
        });

        $("#video_modal .modal-close").click(function () {
          $("#video_modal .modal-content").empty();
          $("#video_modal").removeClass("is-active");
        });
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
